import React, { useState } from 'react';
import LinkedInHeader from './LinkedInHeader';
import './LinkedInTheme.css';
import { HelpCircle, User, Bot, Briefcase, ChevronDown, ChevronUp, Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const HelpCenter = () => {
  const { t } = useTranslation();
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const categories = [
    {
      title: t('helpCenter.sections.gettingStarted.title'),
      icon: <User size={24} />,
      faqs: [
        { q: t('helpCenter.sections.gettingStarted.q1'), a: t('helpCenter.sections.gettingStarted.a1') },
        { q: t('helpCenter.sections.gettingStarted.q2'), a: t('helpCenter.sections.gettingStarted.a2') }
      ]
    },
    {
      title: t('helpCenter.sections.digitalTwins.title'),
      icon: <Bot size={24} />,
      faqs: [
        { q: t('helpCenter.sections.digitalTwins.q1'), a: t('helpCenter.sections.digitalTwins.a1') },
        { q: t('helpCenter.sections.digitalTwins.q2'), a: t('helpCenter.sections.digitalTwins.a2') }
      ]
    },
    {
      title: t('helpCenter.sections.employers.title'),
      icon: <Briefcase size={24} />,
      faqs: [
        { q: t('helpCenter.sections.employers.q1'), a: t('helpCenter.sections.employers.a1') },
        { q: t('helpCenter.sections.employers.q2'), a: t('helpCenter.sections.employers.a2') }
      ]
    }
  ];

  return (
    <div className="li-centered-container">
            
            {/* Header */}
            <div className="li-card" style={{ padding: '40px 24px', textAlign: 'center', backgroundColor: '#fff' }}>
                <div style={{ color: '#0a66c2', marginBottom: '16px' }}><HelpCircle size={48} style={{ margin: '0 auto' }} /></div>
                <h1 style={{ fontSize: '32px', fontWeight: '200', color: 'rgba(0,0,0,0.9)', marginBottom: '8px' }}>
                    {t('helpCenter.header.title')}
                </h1>
                <p style={{ fontSize: '16px', color: 'rgba(0,0,0,0.6)' }}>
                    {t('helpCenter.header.subtitle')}
                </p>
            </div>

            {/* FAQ Sections */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '16px' }}>
                {categories.map((cat, catIndex) => (
                    <div key={catIndex} className="li-card" style={{ padding: '0' }}>
                        <div style={{ padding: '16px 24px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', gap: '12px', backgroundColor: '#f9fafb' }}>
                            <div style={{ color: '#666' }}>{cat.icon}</div>
                            <h2 style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>{cat.title}</h2>
                        </div>
                        <div>
                            {cat.faqs.map((faq, faqIndex) => {
                                const globalIndex = `${catIndex}-${faqIndex}`;
                                const isOpen = openFaq === globalIndex;
                                return (
                                    <div key={faqIndex} style={{ borderBottom: faqIndex === cat.faqs.length - 1 ? 'none' : '1px solid #f3f2ef' }}>
                                        <button 
                                            onClick={() => toggleFaq(globalIndex)}
                                            style={{ 
                                                width: '100%', 
                                                textAlign: 'left', 
                                                padding: '16px 24px', 
                                                background: 'none', 
                                                border: 'none', 
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <span style={{ fontSize: '15px', fontWeight: '500', color: isOpen ? '#0a66c2' : 'rgba(0,0,0,0.9)' }}>{faq.q}</span>
                                            {isOpen ? <ChevronUp size={20} color="#666" /> : <ChevronDown size={20} color="#666" />}
                                        </button>
                                        {isOpen && (
                                            <div style={{ padding: '0 24px 24px', fontSize: '14px', lineHeight: '1.6', color: 'rgba(0,0,0,0.7)' }}>
                                                {faq.a}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>

            {/* Contact Support */}
            <div className="li-card" style={{ padding: '32px 24px', marginTop: '24px', textAlign: 'center' }}>
                <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '16px' }}>{t('helpCenter.contact.title')}</h2>
                <p style={{ fontSize: '14px', color: 'rgba(0,0,0,0.6)', marginBottom: '24px' }}>
                    {t('helpCenter.contact.text')}
                </p>
                <a href="mailto:support@gclouds.co.uk" className="li-btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '10px 24px', borderRadius: '24px' }}>
                    <Mail size={18} /> {t('helpCenter.contact.button')}
                </a>
            </div>
    </div>
  );
};

export default HelpCenter;
